import { observable, action } from 'mobx'
import api from '@api/hua_man'

class Store {
  @observable checkList = []

  @action
  async init() {
    const { data } = await api.getCheckList()
    if (data instanceof Object) {
      if (Object.keys(data).length == 0) {
        this.checkList = []
      } else {
        this.checkList = data
      }
    } else {
      this.checkList = data
    }
  }
}

export default new Store()
